module.exports = __webpack_public_path__ + "img/facebook-icon-white.8227a2e3.svg";